<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="listTypeInfo.width"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="false"
        :right-span-method="objectSpanMethod"
      >
        <template #index="{ scope:{row} }">
          {{row.index}}
        </template>
        <template #handle="{ scope:{row} }">
          <span class="table-handle-btn" @click="goPath(row, '/ES/reportReview/details')">
            {{row.auditStatus===0?'审核':'查看'}}
          </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list-merge';
import Api from '@/modules/projectA/api/ESorganization';
import {
  tableLabel,
  fieldList,
  listTypeInfo
} from './components/componentsData.js';

export default {
  components: { eSearch, eTableList },
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        auditStatus: null,
        creditRound: null,
        supplierType: ''
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      info: {},
      visible: false
    };
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },

  methods: {
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex < 5) {
        if (row.span) {
          return {
            rowspan: row.span,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex > 5) {
        if (row.rightSpan) {
          return {
            rowspan: row.rightSpan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryEvaluationLeaderAuditPage(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const { records, total } = res.data;
          const list = [];
          records.forEach((item, i) => {
            // 如果有覆盖关系
            if (item.evaluationApplyItemPriceVOList && item.evaluationApplyItemPriceVOList[0]?.path) {
              // 前面合并的行数
              const length = item.evaluationApplyItemPriceVOList.length;
              // 一个二维数组，存放合并的单元分享
              const arr = [];
              // 按照覆盖等级排序
              const a = item.evaluationApplyItemPriceVOList.sort((a, b) => a.level - b.level);
              for (let i = 0; i < a.length; i++) {
                // 最高级
                arr.push([{ ...a[i], allId: [a[i].id] }]);
                for (let j = i + 1; j < a.length; j++) {
                  // 复评
                  if (a[i].creditRound !== '1') {
                    continue;
                  }
                  // 判断剩下的有没有被当前的合并，（被覆盖并且状态一样）
                  if (a[j].pathList.includes(a[i].productId.toString()) && a[j].auditStatus === a[i].auditStatus && a[j].creditRound === '1') {
                    arr[arr.length - 1].push(a[j]);
                    // 第一个存放所有的单元分项id
                    arr[arr.length - 1][0].allId.push(a[j].id);
                    // 被合并后删除当前项
                    a.splice(j, 1);
                  }
                }
              }
              arr.flat(2).forEach((item2, index) => {
                list.push({
                  ...item,
                  ...item2,
                  evaluationApplyItemPriceVOList: undefined,
                  span: index === 0 ? length : 0,
                  index: i + 1,
                  rightSpan: item2.allId?.length
                });
              });
            } else {
              item.evaluationApplyItemPriceVOList.forEach((item2, index) => {
                list.push({
                  ...item,
                  ...item2,
                  evaluationApplyItemPriceVOList: undefined,
                  span: index === 0 ? item.evaluationApplyItemPriceVOList.length : 0,
                  rightSpan: 1,
                  index: i + 1
                });
              });
            }
          });
          this.tableData = list;
          this.total = total;
        }
      });
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },
    goPath(row, path) {
      const { applyId, auditStatus, evaluationItemId, id, supplierType, creditRound, allId } = row;
      this.$router.push({
        path,
        query: {
          applyId,
          auditStatus,
          evaluationItemId,
          id,
          creditRound,
          supplierType,
          allId: allId || [id]
        }
      });
    }
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
  @import '@/assets/css/theme.scss';

  .theme {
    color: $main-col;
    cursor: pointer;
  }

  .table-handle-btn + .table-handle-btn {
    margin-left: 10px;
  }
</style>
